import styled from "styled-components";
import { getColor } from "~/helpers/style";

export const FontAwesomeIconWrapper = styled.div<{ color: string | undefined }>`
  color: ${({ color }) => color && getColor(color)};
`;
